// extracted by mini-css-extract-plugin
export var gif = "_hw-0";